import type { RoomBaseboard } from "@/shared/plan";
import { baseboardSection, legacyBlackAluminum } from "./catalog";
import { BaseboardMaterial, type BaseboardCatalogItem, type BaseboardLook } from "./types";

export const getBaseboardMaterial = (material: BaseboardMaterial): BaseboardCatalogItem =>
	material === BaseboardMaterial.BlackAluminum
		? legacyBlackAluminum
		: (baseboardSection.items.find((item) => item.material === material) ??
			baseboardSection.items[0]);

export const baseboardItemById = (id: string): BaseboardCatalogItem | null =>
	id === legacyBlackAluminum.id
		? legacyBlackAluminum
		: (baseboardSection.items.find((item) => item.id === id) ?? null);

export const baseboardLook = (baseboard: RoomBaseboard): BaseboardLook => {
	const item = getBaseboardMaterial(baseboard.material);
	return {
		material: baseboard.material,
		height: Math.max(40, baseboard.height ?? item.height),
		depth: item.depth,
		color: baseboard.color ?? item.color,
		metalness: item.metalness ?? 0,
		recessed: item.recessed ?? false,
	};
};
